export type Bonus = {
  number: number;
  title: string;
  description: string;
  listIntro?: string;
  list: string[];
  listStyle: 'check' | 'steps';
  flow: string[];
};

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'Plan maestro de mantenimiento',
    description: 'Organizá el mantenimiento de tu auto en un solo lugar.',
    listIntro: 'Registrá:',
    list: ['kilometraje', 'services', 'controles', 'aceite y filtros', 'neumáticos', 'batería', 'frenos', 'próximos mantenimientos'],
    listStyle: 'check',
    flow: ['Planificá', 'Controlá', 'Registrá'],
  },
  {
    number: 2,
    title: 'Guía visual del tablero',
    description: 'Una referencia rápida para identificar las principales luces, alertas e indicadores.',
    list: [
      'Encontrá el símbolo.',
      'Entendé qué sistema representa.',
      'Conocé su nivel general de atención.',
      'Sabé cuál debería ser el siguiente paso.',
    ],
    listStyle: 'steps',
    flow: ['Identificá', 'Interpretá', 'Actuá'],
  },
  {
    number: 3,
    title: 'Kit Ruta Argentina',
    description: 'Prepará tu vehículo antes de viajar.',
    listIntro: 'Incluye checklists para:',
    list: ['neumáticos', 'luces', 'fluidos', 'batería', 'documentación', 'elementos de seguridad', 'equipaje', 'combustible', 'clima', 'ruta'],
    listStyle: 'check',
    flow: ['Planificá', 'Revisá', 'Prepará', 'Salí'],
  },
  {
    number: 4,
    title: 'Historial completo de mi auto',
    description: 'Creá el expediente de tu vehículo.',
    listIntro: 'Registrá:',
    list: ['services', 'reparaciones', 'repuestos', 'neumáticos', 'batería', 'frenos', 'gastos', 'garantías', 'controles', 'kilometraje'],
    listStyle: 'check',
    flow: ['Registrá', 'Documentá', 'Consultá'],
  },
  {
    number: 5,
    title: 'Guía para ir al taller',
    description: 'Llegá mejor preparado y organizá toda la información de cada visita.',
    listIntro: 'Registrá:',
    list: [
      'síntomas',
      'ruidos',
      'testigos',
      'kilometraje',
      'diagnóstico informado',
      'presupuesto',
      'repuestos',
      'trabajo realizado',
      'costos',
      'garantía',
    ],
    listStyle: 'check',
    flow: ['Observá', 'Registrá', 'Consultá', 'Documentá'],
  },
];